import React, { useEffect, useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { useNavigate } from "react-router-dom";
import * as Unicons from "@iconscout/react-unicons";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function PdfFlipBook() {
  const navigate = useNavigate();

  // Read data from URL params
  const query = new URLSearchParams(window.location.search);
  const file = query.get("file");
  const bookName = query.get("name");

  const [pages, setPages] = useState([]);
  const [zoom, setZoom] = useState(1);
  const bookRef = useRef();

  // Render a single PDF page
  const renderPage = async (pdf, pageNumber, zoomLevel) => {
    const page = await pdf.getPage(pageNumber);
    const viewport = page.getViewport({ scale: zoomLevel });

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    const outputScale = window.devicePixelRatio || 1;

    canvas.width = viewport.width * outputScale;
    canvas.height = viewport.height * outputScale;

    canvas.style.width = `${viewport.width}px`;
    canvas.style.height = `${viewport.height}px`;

    context.setTransform(outputScale, 0, 0, outputScale, 0, 0);

    await page.render({
      canvasContext: context,
      viewport: viewport,
    }).promise;

    return canvas.toDataURL("image/png");
  };

  // Load PDF
  useEffect(() => {
    if (!file) return;

    const loadPdf = async () => {
      const loadingTask = pdfjsLib.getDocument(file);
      const pdf = await loadingTask.promise;

      const renderedPages = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const img = await renderPage(pdf, i, zoom);
        renderedPages.push(img);
      }

      setPages(renderedPages);
    };

    loadPdf();

    const handleKey = (e) => {
      if (!bookRef.current) return;
      if (e.key === "ArrowRight") bookRef.current.pageFlip().flipNext();
      if (e.key === "ArrowLeft") bookRef.current.pageFlip().flipPrev();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [file, zoom]);

  return (
    <>
     <div className="mt-2">
  <div className="max-w-4xl mx-auto text-center mb-4">
    <div className="w-full flex justify-start mb-3">
      <button
  onClick={() => navigate(-1)}
  className="w-10 h-10 flex items-center justify-center
             rounded-full border border-slate-400
             bg-white hover:bg-slate-100 transition
             text-black"   // ← FIXED COLOR
>
  <Unicons.UilArrowLeft width={18} color="black" />
</button>

    </div>

    <h1 className="text-3xl font-bold tracking-wide">{bookName}</h1>
  </div>
</div>


      <div className="flex justify-center mt-1">
        {pages.length > 0 ? (
          <div className="relative w-full h-[55vh] overflow-auto flex justify-center items-center">
            <div
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: "center center",
                transition: "transform 0.25s ease",
                borderRadius: "8px",
                border: "0.5px solid #2c2a2aff",
              }}
            >
             <HTMLFlipBook
  width={500}
  height={900}
  showCover={true}
  mobileScrollSupport={true}
  usePortrait={false}
  startPage={0}
  className="shadow-xl rounded-lg cursor-pointer 
             border border-slate-700 dark:border-slate-300"
  ref={bookRef}
>

                {pages.map((src, index) => (
                  <div key={index} className="bg-white h-full p-4">
                    <img
                      src={src}
                      className="w-full h-full object-contain"
                      draggable={false}
                    />
                  </div>
                ))}
              </HTMLFlipBook>
            </div>

            <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
              <button
  onClick={() => bookRef?.current?.pageFlip()?.flipPrev()}
  className="w-12 h-12 flex items-center justify-center rounded-full border text-black"
>
  <Unicons.UilArrowLeft size={20} color="black" />
</button>

<button
  onClick={() => setZoom((prev) => Math.min(prev + 0.2, 3))}
  className="w-12 h-12 flex items-center justify-center rounded-full border text-black"
>
  <Unicons.UilPlus size={20} color="black" />
</button>

<button
  onClick={() => setZoom((prev) => Math.max(prev - 0.2, 0.4))}
  className="w-12 h-12 flex items-center justify-center rounded-full border text-black"
>
  <Unicons.UilMinus size={20} color="black" />
</button>

<button
  onClick={() => bookRef?.current?.pageFlip()?.flipNext()}
  className="w-12 h-12 flex items-center justify-center rounded-full border text-black"
>
  <Unicons.UilArrowRight size={20} color="black" />
</button>

            </div>
          </div>
        ) : (
          <div>
            {/* <h1 className="text-2xl font-bold text-center tracking-wide">
              {bookName}
            </h1> */}
            <br />
            <p className="text-center text-slate-500">Loading PDF...</p>
            <Skeleton count={5} width={1000} height={100} />
          </div>
        )}
      </div>
    </>
  );
}
